<template lang="pug">
#activity_form
  section.title-box
    .title-box__title {{title}}
    span.title-box__subtitle(v-show="actionPlan") {{actionPlan}}
    .title-box__event-time(v-show="eventTimeString") 活動時間 | {{eventTimeString}}
  hr
  section.about-box
    .about-box__title ABOUT
    p.about-box__content {{actionDetail}}
  section.event-time-box
    .event-time-box__time-box  START
      .data {{applyFromList[0]}}
      .time {{applyFromList[1]}}
    .event-time-box__process-box
      .process-bars
        .process-bars__default
        .process-bars__curr(:style="{'--pWidth': precessCurrLength}")
      .current-date {{currDate}}
      .current-time {{currTime}}
    .event-time-box__time-box FINISH
      .data {{applyToList[0]}}
      .time {{applyToList[1]}}
  main.application-form(v-if="stateCode === 1")
    MyFormBlocks(
      :eventTo="time.eventTo"
      :eventFrom="time.eventFrom"
      :fieldsData="fieldsData"
      ref="myFormBlocksEl"
    )
    v-row.file-box(v-if="attachment || upload")
      v-col(v-if="attachment")
        v-btn(color="#2196F3" @click="downloadFile").btn 資料下載
          v-icon(right) mdi-cloud-download
        p.file-title {{attachment.name}}
      v-col(v-if="upload")
        v-form(ref="fileFormEl")
          v-file-input(
            chip
            placeholder="上傳檔案"
            counter="1"
            :rules="rules.file"
            messages="max size 500 MB"
            v-model="file"
          )
    .row.actions
      .col
        v-btn(@click="submit" :disabled="isProcessing") 送出
  main.application-form(v-else)
    .form-alert-info {{formAlertInfo}}
    .row.actions
      .col
        v-btn(@click="goBackList") 回到上傳資料頁


</template>
<script src="//unpkg.com/@element-plus/icons-vue"></script>

<script>
import { ok,ng, warn } from '@/utils/msg'

import { fetchApplicationForm, updateApplicationForm } from '@/api/client/ApplicationForm'
import MyFormBlocks from './MyFormBlocks'

export default {
  components: { MyFormBlocks },
  data() {
    return {
      isProcessing: false,
      isDev: false,
      dummyId: '2022-10-27 10:04:30.156;1396147344',
      file: null,
      rules: {
        file: [
          val=> !val || val.size < 500000000 || '超過檔案最大限制 500 MB',
          val=> !!val || '需要上傳檔案'
        ]
      },
      title: '',
      actionDetail: '',
      switch: true,
      upload: false,
      formType: '',
      actionPlan: '',
      actionType: '',
      attachment: null,
      formAlertInfo: '讀取中...',
      percent: 0,
      time: {
        currTime: null,
        applyFrom: '',
        applyTo: '',
        eventFrom: '',
        eventTo: '',
      },
      fieldsData: null,
    }
  },
  computed: {
    requestId () {
      return this.isDev ? this.dummyId: this.formId
    },
    applyFromList() {
      return this.getTimeList(this.time.applyFrom)
    },
    applyToList() {
      return this.getTimeList(this.time.applyTo)
    },
    eventTimeString() {
      if(!this.time.eventFrom && !this.time.eventTo) return null
      return `${this.time.eventFrom} - ${this.time.eventTo}`
    },
    currDate() {
      return new Date().toLocaleDateString()
    },
    currTime() {
      return new Date(this.time.currTime).toTimeString().split(' ')[0].slice(0, 5)
    },
    formId() {
      return this.$route.params.formId
    },
    stateCode() {
      if(this.time.currTime == null) return -1
      if (new Date(this.time.currTime) > new Date(this.time.applyTo)) {
        this.formAlertInfo = '填報時間已結束'
        this.percent = 0
        return 2
      }
      if (new Date(this.time.currTime) < new Date(this.time.applyFrom)) {
        this.formAlertInfo = '尚未開放報名'
        this.percent = 0
        return 0
      }
      this.formAlertInfo = ''
      this.getTimePercent()
      return 1
    },
    precessCurrLength() {
      return `${this.percent}%`
    }
  },
  methods: {
    checkFile() {
      const isValid = this.$refs.fileFormEl.validate()
      const err = new Error('required file')
      err.warnMsg ='請完整輸入表單'
      if(!isValid) throw err
    },
    goBackList(){
      if(this.formType.includes('results')) {
        this.$router.push({name: 'activity_results'})
        return
      }
      this.$router.push({name: 'activity'})

    },
    async submit() {
      try {
        if(this.isProcessing) return

        const{ emitFormData } = this.$refs.myFormBlocksEl
        const data = await emitFormData()
        if(!data) return

         const file = this.upload ? this.file : null
        if(this.upload) this.checkFile()

        const payload = {
          data: data.map(e => e.value),
          status: 1
        }
        this.isProcessing =true
        const res = await updateApplicationForm(this.requestId, payload, file)
        const { errcode } = res
        if(errcode > 0) throw new Error(res.errmsg)
        ok('報名成功')
        this.isProcessing = false
      } catch(err) {
        console.warn(err)
        if(err.warnMsg) return warn(err.warnMsg)
        ng('報名失敗')
        this.isProcessing = false
      }
    },
    downloadFile() {
      const link = document.createElement('a')
      link.href = this.attachment.src || this.attachment.info.src
      link.target='_blank'
      link.click()
    },
    getTimeList(time) {
      if (time === '' || time == null) return ['', '']
      let [t1, t2] = time.split(' ')
      return [t1, t2.slice(0, 5)]
    },
    startCountTime() {
      setTimeout(() => {
        this.time.currTime = new Date()
        this.startCountTime()
      }, 1000)
    },
    async getApplicationFormData() {
      const { data } = await fetchApplicationForm(this.requestId)
      if (data == null) this.$router.push({name: 'NotFound'})
      const { actionDetail, title,
        fields,
        apply_from, apply_to,
        event_from, event_to,
        attachment
      } = data
      const { switch: switchValue,
        actionPlan, actionType,
        fieldsData, form_type,
        upload
      } = fields
      this.actionType = actionType
      this.actionDetail = actionDetail
      this.title = title
      this.time.applyFrom = apply_from
      this.time.applyTo = apply_to
      this.time.eventFrom = event_from
      this.time.eventTo = event_to
      this.actionPlan = actionPlan
      this.switch = switchValue
      this.upload = upload
      this.attachment = attachment
      this.formType = form_type
      this.fieldsData = fieldsData
    },
    getTimePercent() {
      const total = new Date(this.time.applyTo) - new Date(this.time.applyFrom)
      const curr = new Date() - new Date(this.time.applyFrom)
      this.percent = (curr / total * 100).toFixed(2)
    }
  },
  async created() {
    this.startCountTime()
    await this.getApplicationFormData()
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'
@keyframes process
  100%
    transform: translateX(-8px)
#activity_form
  min-width: 300px
  --bdrs: 4px
  --pWidth: 0
  font-weight: 700
  max-width: 1000px
  margin: auto
  padding: 80px 40px
  +pad
    margin-inline: 10px
hr
  height: 1px
  border: 0
  margin-block: 10px 20px
  background-image: linear-gradient(90deg,transparent,#ababab,transparent);
.title-box
  &__title
    color: #555
    font-size: 40px
    font-weight: 700px
    margin-bottom: 10px
    font-size: 28px
  &__subtitle
    color: white
    background-color: #999
    border-radius: 6px
    padding: 2px 8px
    font-size: 13px
    line-height: 25px
    letter-spacing: 2px
  &__event-time
    margin-block: 10px
    font-size: 12px
    color: #333
.event-time-box
  display: flex
  justify-content: space-between
  font-size: 12px
  text-align: center
  padding-inline: 30px
  &__time-box
    color: #37474f
    border: 2px solid black
    padding: 5px
    width: 120px
    +pad
      width: 100%
  &__process-box
    width: 60%
    color: #78909c
    .current-date
      margin-top: 10px
    .current-time
      margin-top: 10px
    +pad
      width: 100%
      margin-block: 40px
    .process-bars
      overflow: hidden
      border-radius: var(--bdrs)
      width: 100%
      height: 8px
      position: relative
      &__default
        opacity: 0.5
        width: 100%
        height: 100%
        position: absolute
        animation: process .25s linear infinite
        border-top: 4px dotted #37474f
        right: -8px
        top: 2px
      &__curr
        height: 100%
        width: var(--pWidth)
        background-color:#37474f
  +pad
    display: flex
    flex-direction: column
    align-items: center

.actions
  margin-top: 1rem
  text-align: center
.about-box
  margin: 0 2rem 2rem
  border: 1px solid
  border-color: rgb(204, 204, 204)
  padding: 1rem
  letter-spacing: 1.5px
  // border-radius: var(--bdrs)
  &__title
    line-height: 24px
    letter-spacing: 1.5px
    text-align: center
    margin-bottom: 1rem
  &__content
    line-height: 26px
    font-size: 15px
    padding-inline: 1rem
    margin-bottom: 1rem
.form-alert-info
  margin: 2rem
  border: 1px solid red
  border-radius: var(--bdrs)
  font-size: 26px
  padding: 1rem
  text-align: center
.file-box
  margin-block: 20px
  text-align: center
  .btn
    color: white
    margin-block-end: 6px
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForm/ApplicationForm.vue